import { X } from 'lucide-react';

// organism — DWR undo toast bottom-center con countdown. Pattern `.undo-toast`
// mockup (styles.css 2063-2098 + app.jsx 464-472): fixed bottom 1rem,
// left-50% translateX, bg-ink, text-paper-bright, font-serif body + font-display
// strong per countdown, gap 1rem, slide-in animation. Ghost button "↶ Annulla"
// + close `×` opacità 0.6→1 hover.
//
// API stateless: il countdown è gestito esternamente via `useUndoCountdown`.
// Il consumer controlla `open`, `message`, `secondsLeft` e i callback.
//
// ARIA `role="alert"` per assistive tech (azione reversibile, l'utente deve
// poter intervenire rapidamente).

interface UndoToastProps {
  open: boolean;
  message: string;
  secondsLeft: number;
  onUndo: () => void;
  onDismiss: () => void;
}

export function UndoToast({ open, message, secondsLeft, onUndo, onDismiss }: UndoToastProps) {
  if (!open) return null;
  // Centrato via `inset-x-0 mx-auto w-fit` invece di `left-1/2 -translate-x-1/2`
  // per evitare conflitto col `transform: translateY(...)` dell'animation
  // `undo-slide-in` (un solo asse di transform attivo per volta).
  return (
    <div
      role="alert"
      className="bg-ink text-paper-bright animate-undo-slide-in font-serif fixed inset-x-3 bottom-4 z-[1000] mx-auto flex w-fit max-w-[calc(100vw-1.5rem)] items-center gap-3 px-[1.1rem] py-[0.7rem] shadow-[0_6px_18px_rgba(0,0,0,0.25)] sm:gap-4"
    >
      <span className="text-[0.92rem] sm:text-base">
        {message}{' '}
        <strong className="font-display font-bold tracking-[0.06em]">{secondsLeft}s</strong>
      </span>
      <button
        type="button"
        onClick={onUndo}
        className="text-paper-bright border-paper-bright font-display hover:bg-paper-bright/10 shrink-0 border bg-transparent px-3 py-1.5 text-xs tracking-[0.08em] uppercase transition"
      >
        ↶ Annulla
      </button>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Chiudi"
        className="text-paper-bright -mr-2 grid h-11 w-11 shrink-0 cursor-pointer place-items-center border-0 bg-transparent opacity-60 transition hover:opacity-100"
      >
        <X aria-hidden className="h-4 w-4" strokeWidth={2.2} />
      </button>
    </div>
  );
}
